import { ComponentIdEnum } from '../component-factory/ComponentIdEnum';
// eslint-disable-next-line import/no-cycle

import { ElementConfigType } from '../store/type';

// 适配详描旧数据没有isSlot字段
export const nodeIsSlot = (node: ElementConfigType | null) => {
  if (!node) return false;
  if (node.isSlot) {
    return node.isSlot;
  }
  return node.componentId === ComponentIdEnum.BODY_COMPONENT || node.componentId === ComponentIdEnum.BASIC_COMPONENT;
};

/** 判断是否是容器组件（多行/多列）容器 */
export const judgeIsContainer = (componentConfig: ElementConfigType | null) => {
  if (!componentConfig) return false;
  if (componentConfig.isContainer) {
    return componentConfig.isContainer;
  }
  return (
    componentConfig.componentId === ComponentIdEnum.COLUMNS_CONTAINER_COMPONENT ||
    componentConfig.componentId === ComponentIdEnum.ROWS_CONTAINER_COMPONENT
  );
};

/** 用于大纲树与视图的交互，点击一方另一方的元素可以出现在视口 */
export const scrollToSelectEl = (nodeId: string, prefix: string) => {
  const el = document.querySelector(`#${prefix}${nodeId}`);
  if (!el) return;
  el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

/** 把React内敛的小驼峰转换为中划线命名 */
export const transformReactCSS = (reactStyle: any) => {
  const temp = {};
  // eslint-disable-next-line guard-for-in
  for (const key in reactStyle) {
    const newKey = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    temp[newKey] = `${reactStyle[key]}`;
  }

  return temp;
};
